import * as d3 from 'd3'

const tooltipRadius = 20

export default class Tooltip {
    constructor({ data, colorScale, node, xScale, yScale }, isHovered) {
        this.data = data
        this.colorScale = colorScale
        this.node = node
        this.xScale = xScale
        this.yScale = yScale
        this.isHovered = isHovered
        this.$tooltipTemplate = document.querySelector('.arm-tooltip')

        this.$el = this.$tooltipTemplate.cloneNode(true)
        this.$tooltip = d3.select(this.$el).attr('opacity', 1)

        this.$parent = this.$tooltipTemplate.parentNode

        this.$parent.appendChild(this.$el)

        // What does this do?
        this.$tooltip
            .select('.tooltip-bubble')
            .attr('stroke', colorScale(data.position))

        this.$tooltip
            .select('.tooltip-name')
            .text(data.name)
            .attr('opacity', isHovered ? 1 : 0)

        const textWidth = this.$tooltip
            .select('.tooltip-name')
            .node()
            .getComputedTextLength()

        const rectWidth = textWidth + 20

        this.$tooltip
            .select('.tooltip-name-bg')
            .attr('width', rectWidth)
            .attr('x', -rectWidth / 2)
            .attr('opacity', isHovered ? 1 : 0)

        this.moveMaxBubble(xScale)

        this.$tooltip
            .raise()
            // .transition() .duration(200)
            .attr('opacity', 1)
            .select('.tooltip-value')
            .attr('fill', colorScale(data.position))
            .text(`${data.arm.toFixed(1)}`)
    }

    moveMaxBubble(xScale) {
        const xDiff = Math.max(
            xScale(this.data.max) - xScale(this.data.arm),
            tooltipRadius
        )
        this.$tooltip
            .select('.max-bubble-text')
            .attr('opacity', this.isHovered ? 1 : 0)
            // .transition()
            .attr('transform', `translate(${xDiff}, 0)`)
            .select('text')
            .attr(
                'transform',
                this.data.position === '1b' ? 'rotate(45)' : 'rotate(-45)'
            )

        this.$tooltip
            .select('.max-bubble-rect')
            .attr(
                'transform',
                this.data.position === '1b' ? 'rotate(45)' : 'rotate(-45)'
            )

        this.$tooltip
            .select('.max-bubble')
            // .transition()
            .attr('cx', xDiff)
            .attr('fill', this.colorScale(this.data.position))
            .attr('opacity', this.isHovered ? 1 : 0)

        this.$tooltip
            .select('.max-bubble-line')
            // .transition()
            .attr('width', xDiff)
            .attr('fill', this.colorScale(this.data.position))
            .attr('opacity', this.isHovered ? 1 : 0)

        this.move()
    }

    move() {
        const x = this.node.attr('cx')
        const y = this.node.attr('cy')
        this.$tooltip.attr('transform', `translate(${x}, ${y - 35})`)
    }

    remove() {
        this.$el.remove()
    }
}
